import { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from "app/redux/reducer";
import { bindActionCreators, Dispatch } from 'redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { TextField, PrimaryButton, Dropdown } from 'office-ui-fabric-react';

import { deleteActivity, getActivities, IActivity } from 'app/services/activity';
import { MessageType } from 'app/redux/system/types';
import { publishActivityVariantByActivity } from 'app/services/activity-variant';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import { deleteRecovery, getRecoveries, updateRecovery } from 'app/services/recovery';
import PageLayout from 'containers/PageLayout';

import PageTitle from 'components/customs/PageTitle';
import BasicTable from 'components/customs/BasicTable';
import { castThunkAction } from 'app/utils/casting';
import { showMessage, toggleConfirmDialog } from 'app/redux/system/actions';

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        language: state.system.language,
        pageData: state.page.pageData as IList<IActivity[]>,
        defaultLanguage: state.system.defaultLanguage
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        deleteActivity,
        getActivities,
        toggleConfirmDialog,
        publishActivityVariantByActivity,
        getRecoveries,
        updateRecovery,
        deleteRecovery,
        showMessage
    }, dispatch);
}

type IListActivityProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class ListActivity extends Component<IListActivityProps, IListState> {

    state = {
        type: "activity",
        filterObject: {
            title: "",
            status: 1,
            isWebPublish: undefined,
            createdOn: "",
            isActive: undefined,
            language: this.props.defaultLanguage
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 10
        },
        activeStatus: StatusEnum.Published
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onEnterSearch, true);
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onEnterSearch, true);
    }

    onEnterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.searchList();
        }
    };

    makeRequest(options: IListFilter) {
        if (this.state.filterObject.status === StatusEnum.Deleted) {
            castThunkAction(this.props.getRecoveries(options, this.state.type))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction(this.props.getActivities(options)).then(() => {
                this.setState({
                    activeStatus: this.state.filterObject.status,
                })
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 10
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row">
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <Dropdown
                    options={[
                        { key: StatusEnum.Published, text: "Yayında" },
                        { key: StatusEnum.Deleted, text: "Silinmiş" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Duruma Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={this.state.filterObject?.status}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "status": option.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <Dropdown
                    options={[
                        { key: 'all', text: "Tümü" },
                        { key: 'true', text: "Web'de gösterilsin" },
                        { key: 'false', text: "Web'de gösterilmesin" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Gösterim Durumuna Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={typeof this.state.filterObject?.isWebPublish === "undefined" ?
                        "all" : this.state.filterObject.isWebPublish}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "isWebPublish": option?.key === "all" ? undefined : option?.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <Dropdown
                    options={[
                        { key: 'all', text: "Tümü" },
                        { key: 'true', text: "Satışta olanlar" },
                        { key: 'false', text: "Satışta olmayanlar" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Satışta Olup Olmadığına Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={typeof this.state.filterObject?.isActive === "undefined" ?
                        "all" : this.state.filterObject.isActive}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                isActive: option?.key === "all" ? undefined : option?.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "37px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <BasicTable
                totalCount={this.props.pageData.totalCount}
                columns={[
                    {
                        columnName: "adminTitle",
                        text: "Etkinlik Adı",
                        col: "col-md-2",
                        onRender: (item: IActivity) => {
                            return (
                                <Link to={`/activity/edit/${item.id}`}>
                                    {item.adminTitle || item.title}
                                </Link>
                            )
                        }
                    },
                    {
                        columnName: "key",
                        text: "Etkinlik Anahtarı",
                        col: "col-md-2"
                    },
                    {
                        columnName: "isWebPublish",
                        text: "Web'de Gösterim",
                        col: "col-md-1",
                        onRender: (item: IActivity) => {
                            if (item.isWebPublish) {
                                return <span className="td-button" style={{ background: "#2b925f" }}>Göster</span>
                            } return <span className="td-button" style={{ background: "#ede0d6", color: "#a74d09" }}>Gizle</span>
                        }
                    },
                    {
                        columnName: "variantDate",
                        text: "Seans Tarihi",
                        col: "col-md-2"
                    },
                    {
                        columnName: "order",
                        text: "Etkinlik Sırası",
                        col: "col-md-1"
                    },
                    {
                        columnName: "listDateOrder",
                        text: "Tarih Sırası",
                        col: "col-md-1",
                        onRender: (item: IActivity) => {
                            return <span>{item.dateOrder || "0"}</span>
                        }
                    },
                    {
                        columnName: "operations",
                        text: "İşlemler",
                        col: "col-md-3",
                        onRender: (item) => {
                            if (this.state.activeStatus !== StatusEnum.Deleted) {
                                return (
                                    <>
                                        <div
                                            className="status-button active"
                                            onClick={() => {
                                                this.props.toggleConfirmDialog(true, {
                                                    callback: () => {
                                                        castThunkAction(this.props.deleteActivity(item.id as string)).then(res => {
                                                            if (res) {
                                                                this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
                                                            }
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            Sil
                                        </div>
                                        <div
                                            className="status-button gray"
                                            onClick={() => {
                                                this.props.toggleConfirmDialog(true, {
                                                    title: "Tüm seanslar yayımlansın mı?",
                                                    text: "Seçtiğiniz etkinliğe ait tüm seansları yayımlamak istiyor musunuz? Eğer istiyorsanız 'Tümünü yayımla' butonuna basınız.",
                                                    button: {
                                                        approveText: "Tümünü yayımla"
                                                    },
                                                    callback: () => {
                                                        castThunkAction(this.props.publishActivityVariantByActivity(item.id as string)).then(response => {
                                                            this.props.showMessage("Geçerli etkinliğe ait tüm seanslar başarıyla güncellendi. ", "İşlem başarıyla tamamlandı!", MessageType.SUCCESS)
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            Seansları yayımla
                                        </div>
                                        <div
                                            className="status-button"
                                            onClick={() =>
                                                this.props.history.push(`/activity/edit/${item.id}`)
                                            }
                                        >
                                            Düzenle
                                        </div>
                                    </>
                                );
                            } return (
                                <>
                                    <div
                                        className="status-button active"
                                        onClick={() => {
                                            this.props.toggleConfirmDialog(true, {
                                                callback: () => {
                                                    castThunkAction(this.props.deleteRecovery(item.id as string)).then(res => {
                                                        if (res) {
                                                            this.searchList()
                                                        }
                                                    })
                                                }
                                            })
                                        }}
                                    >
                                        Kalıcı Olarak Sil
                                    </div>
                                    <div
                                        className="status-button"
                                        onClick={() =>
                                            castThunkAction(this.props.updateRecovery(this.state.type, item.id as string)).then(res => {
                                                if (res) {
                                                    this.searchList()
                                                }
                                            })
                                        }
                                    >
                                        Kurtar
                                    </div>
                                </>
                            )
                        }
                    },
                ]}
                items={this.props.pageData.list}
                showPager={true}
                pageCount={this.props.pageData.pageCount}
                onChangePageSize={(pageSize) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        pageSize
                    }))
                }}
                onChangePager={(pageNumber) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        page: pageNumber
                    }))
                }}
                pageIndex={this.state.pagerObject.page - 1}
            />
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Etkinlik Yönetimi"
                        subTitle="Tüm etkinlikleri aşağıdan görüntüleyebilir, düzenleme yapabilir veya yeni bir etkinlik ekleyebilirsiniz."
                        backUrl="/"
                        showBack
                        history={this.props.history}
                    />
                    <PrimaryButton
                        onClick={() => this.props.history.push("/activity/create")}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Etkinlik Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />
                    {this.renderFilter()}
                    {this.renderList()}
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListActivity);